// What may be uploaded into the crew-docs bucket (sec-fix). ONE list for the browser (a clear message before the upload), the
// server route api/upload-cert.js (it checks the file's first bytes, not the type the browser claims) and the bucket itself
// (sql/sec-fix.sql sets storage.buckets allowed_mime_types + file_size_limit from the same values; tests/sec-fix.test.mjs checks
// they match). Never SVG, HTML, XML or scripts: a file the browser would RUN when its signed link is opened.
// application/octet-stream stays allowed: a browser that does not know a file's type (.heic on Chrome, .doc on some PCs) sends
// that, and such a file is only ever downloaded, never shown as a page.
export const UPLOAD_MIME = [
  'application/pdf',
  'image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/heic', 'image/heif',
  'video/mp4', 'video/webm', 'video/quicktime', 'video/x-m4v', 'video/3gpp',
  'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain', 'text/csv',
  'application/octet-stream',
]
export const UPLOAD_MAX_MB = 50
// file names the bucket refuses for a new upload whatever type is claimed (sql/sec-fix.sql hc_storage_can)
export const BLOCKED_EXT = /\.(svgz?|html?|xhtml?|xht|xml|xsl|xslt|js|mjs|cjs|php|swf)$/i

// -> a message, or null when the file may be uploaded
export function uploadProblem(file) {
  if (!file) return 'Choose a file'
  const name = String(file.name || ''), type = String(file.type || '').toLowerCase().split(';')[0].trim()
  if (BLOCKED_EXT.test(name)) return 'This kind of file cannot be uploaded (web pages, SVG and script files are refused). Use a PDF, a photo or an Office file.'
  if (type && !UPLOAD_MIME.includes(type)) return 'This kind of file cannot be uploaded (' + type + '). Use a PDF, a photo, a video or an Office file.'
  if (Number(file.size) > UPLOAD_MAX_MB * 1024 * 1024) return 'That file is over ' + UPLOAD_MAX_MB + ' MB'
  return null
}

// the real type of a PDF / photo from its first bytes (null = none of these): the server never trusts the claimed type
export function sniffType(buf) {
  const b = buf && buf.length != null ? buf : []
  const at = (i, ...xs) => xs.every((x, k) => b[i + k] === x)
  if (at(0, 0x25, 0x50, 0x44, 0x46, 0x2d)) return 'application/pdf'                 // %PDF-
  if (at(0, 0xff, 0xd8, 0xff)) return 'image/jpeg'
  if (at(0, 0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a)) return 'image/png'
  if (at(0, 0x47, 0x49, 0x46, 0x38)) return 'image/gif'                             // GIF8
  if (at(0, 0x52, 0x49, 0x46, 0x46) && at(8, 0x57, 0x45, 0x42, 0x50)) return 'image/webp' // RIFF....WEBP
  if (at(4, 0x66, 0x74, 0x79, 0x70)) {                                               // ....ftyp<brand>: an iPhone photo
    const brand = String.fromCharCode(b[8], b[9], b[10], b[11])
    if (['heic', 'heix', 'hevc', 'heim', 'heis', 'mif1', 'msf1'].includes(brand)) return 'image/heic'
  }
  return null
}
